/**
 * Servicio centralizado para llamadas a la API
 * Configura la URL base y headers comunes
 */
import axios from 'axios';

export const CodigoNotaria = '4';
export const UrlApi = process.env.REACT_APP_UrlApi;

// Links de redes sociales. Si el proyecto no tiene cuenta propia, se usa el
// home genérico de cada red. Para apuntar a una cuenta real, definir la
// variable de entorno correspondiente (REACT_APP_SOCIAL_*) en el .env.
export const SocialLinks = {
  facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/',
  instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/',
  x: process.env.REACT_APP_SOCIAL_X || 'https://www.x.com/',
};

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: process.env.REACT_APP_UrlApi || '',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', error.response?.data || error.message);
    }
    return Promise.reject(error);
  }
);

/**
 * Servicios de la API organizados por módulo
 */
export const apiService = {
  // Notaría
  getNotaria: () => api.get('notaria'),

  // Cotizador
  getConfigCotizador: () => api.get('configCotizador'),
  cotizarPublico: (data) => api.post('cotizador/cotizar', data),

  // Ubicación
  getPaises: () => api.get('paises'),
  getDepartamentos: () => api.get('departamentos'),
  getMunicipios: () => api.get('municipios'),

  // Solicitudes
  getTipoSolicitud: () => api.get('tipo_solicitud'),
  crearPQR: (formData) => api.post('pqr', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Contacto
  enviarContacto: (data) => api.post('MailContact', data),
};

// Exportar instancia de axios para usos personalizados
export default api;